import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { equals, gt, length, lt } from "ramda";
import { useSelected } from "../OrganizeProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareX } from "@fortawesome/pro-solid-svg-icons";

import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  icon: {
    "& > :first-child": {
      fontSize: "1.4rem",
    },
  },
}));

const SelectedFilesCheckbox = ({
  content,
  isPagedContent = false,
  total = null,
  title = "Remove All Selected",
}) => {
  const classes = useStyles();
  const {
    appendToSelectedContent,
    removeAllSelectedContent,
    selectedContent,
  } = useSelected();

  const [checkbox, setCheckbox] = useState({
    checked: false,
    indeterminate: false,
  });
  useEffect(() => {
    if (gt(length(selectedContent), 0)) {
      const count = total || length(content);
      setCheckbox({
        checked: equals(length(selectedContent), count),
        indeterminate: lt(length(selectedContent), count),
      });
    }
  }, [content, selectedContent, total]);

  const handleChange = event => {
    if (isPagedContent) {
      removeAllSelectedContent();
    } else {
      appendToSelectedContent(checkbox, content);
    }
  };

  return (
    <Grid item style={{ paddingLeft: 15 }}>
      {isPagedContent ? (
        <Tooltip title={title} placement="bottom">
          <Button
            onClick={handleChange}
            startIcon={<FontAwesomeIcon icon={faSquareX} />}
            classes={{
              iconSizeMedium: classes.icon,
            }}
            style={{ fontWeight: 700 }}
          >
            {" " + length(selectedContent) + " selected"}
          </Button>
        </Tooltip>
      ) : (
        <FormControlLabel
          label={
            <Typography variant="h2">
              {`${length(selectedContent)} selected`}
            </Typography>
          }
          control={
            <Checkbox
              color="primary"
              indeterminate={checkbox.indeterminate}
              checked={checkbox.checked}
              onChange={handleChange}
              inputProps={{ "aria-label": "Select" }}
            />
          }
        />
      )}
    </Grid>
  );
};

export default SelectedFilesCheckbox;
